/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */
/**
var disableddates = [theme.disabledDates]; //  format m/dd/yyyy

    $(document).ready( function() {
      $(function() {
        $('#order-date').datepicker( {
          todatHighlight: true,
          minDate: 0,
          dateFormat: 'dd-MM-yy',
          maxDate: '+2M',
          beforeShowDay: disableSpecificDates
      	}); 
      });
    });

    function noSunday(date) {
      return [date.getDay() !=0, ''];	
    }

    function disableSpecificDates(date) {
     var m = date.getMonth();
     var d = date.getDate();
     var y = date.getFullYear();

     // First convert the date in to the mm-dd-yyyy format 
     // Take note that we will increment the month count by 1 
     var currentdate = (m + 1) + '-' + d + '-' + y ;

     // We will now check if the date belongs to disableddates array 
     for (var i = 0; i < disableddates.length; i++) {

        // Now check if the current date is in disabled dates array. 
        if ($.inArray(currentdate, disableddates) != -1 ) {
            return [false];
        } 
     }

     // In case the date is not present in disabled array, we will now check if it is a weekend. 
     // We will use the noWeekends function
     var weekenddate = noSunday(date);
     return weekenddate; 
    }
**/
document.addEventListener('click', function (event) {
  var button = event.target.closest('[data-quick-add-button]');
  if (!button) {
    return;
  }

  event.preventDefault();
  event.stopPropagation();

  if (button.hasAttribute('disabled')) {
    return;
  }

  var variantId = button.getAttribute('data-variant-id');

  button.setAttribute('disabled', 'disabled');
  button.classList.add('is-loading');

  fetch('/cart/add.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
    .then(function (response) {
      return response.json().then(function (data) {
        return { ok: response.ok, data: data };
      });
    })
    .then(function (result) {
      button.removeAttribute('disabled');
      button.classList.remove('is-loading');

      if (!result.ok) {
        button.classList.add('has-error');
        button.setAttribute('title', result.data.description || 'Could not add to cart');
        setTimeout(function () {
          button.classList.remove('has-error');
        }, 2500);
        return;
      }

      document.dispatchEvent(new CustomEvent('product:added', {
        bubbles: true,
        detail: {
          variant: result.data,
          quantity: result.data.quantity
        }
      }));
    })
    .catch(function () {
      button.removeAttribute('disabled');
      button.classList.remove('is-loading');
    });
});

(function () {
  var input = document.getElementById('card-message');
  if (!input) {
    return;
  }

  var counter = document.getElementById('card-message-counter');
  var warning = document.getElementById('card-message-warning');
  var maxLength = parseInt(input.getAttribute('maxlength'), 10) || 150;
  var nonLatinScript = /[Ͱ-ϿЀ-ӿ֐-׿؀-ۿऀ-ॿ฀-๿぀-ヿ一-鿿가-힯]/;

  function update() {
    if (counter) {
      counter.textContent = (maxLength - input.value.length) + ' characters remaining';
    }
    if (warning) {
      warning.style.display = nonLatinScript.test(input.value) ? 'block' : 'none';
    }
  }

  var savedMessage = sessionStorage.getItem('wf_cart_card_message');
  if (savedMessage) {
    input.value = savedMessage;
    sessionStorage.removeItem('wf_cart_card_message');
  }

  var notesEl = document.getElementById('order-notes');
  var savedNotes = sessionStorage.getItem('wf_cart_order_notes');
  if (notesEl && savedNotes) {
    notesEl.value = savedNotes;
    sessionStorage.removeItem('wf_cart_order_notes');
  }

  input.addEventListener('input', update);
  update();
})();

document.addEventListener('click', function (event) {
  var button = event.target.closest('[data-vase-add-btn]');
  if (!button) {
    return;
  }

  event.preventDefault();

  if (button.hasAttribute('disabled')) {
    return;
  }

  var variantId = button.getAttribute('data-variant-id');
  var useReload = button.hasAttribute('data-vase-reload');
  var originalLabel = button.textContent;

  button.setAttribute('disabled', 'disabled');
  button.textContent = '...';

  fetch('/cart/add.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
    .then(function (response) {
      return response.json().then(function (data) {
        return { ok: response.ok, data: data };
      });
    })
    .then(function (result) {
      if (!result.ok) {
        button.removeAttribute('disabled');
        button.textContent = originalLabel;
        button.setAttribute('title', result.data.description || 'Could not add to cart');
        return;
      }

      if (useReload) {
        var notesEl = document.getElementById('order-notes');
        var messageEl = document.getElementById('card-message');

        if (notesEl && notesEl.value) {
          sessionStorage.setItem('wf_cart_order_notes', notesEl.value);
        }
        if (messageEl && messageEl.value) {
          sessionStorage.setItem('wf_cart_card_message', messageEl.value);
        }

        window.location.reload();
        return;
      }

      document.dispatchEvent(new CustomEvent('product:added', {
        bubbles: true,
        detail: {
          variant: result.data,
          quantity: result.data.quantity
        }
      }));
    })
    .catch(function () {
      button.removeAttribute('disabled');
      button.textContent = originalLabel;
    });
});

